// GENERATED by scripts/onboarding/gen-audio-map.mjs - do not edit.
/* eslint-disable @typescript-eslint/no-require-imports */
export const AUDIO_CLIPS: Record<string, number> = {
  done_1: require('../../../assets/onboarding/audio/done_1.mp3'),
  done_2: require('../../../assets/onboarding/audio/done_2.mp3'),
  done_3: require('../../../assets/onboarding/audio/done_3.mp3'),
  p1_1_1: require('../../../assets/onboarding/audio/p1_1_1.mp3'),
  p1_1_2: require('../../../assets/onboarding/audio/p1_1_2.mp3'),
  p1_1_3: require('../../../assets/onboarding/audio/p1_1_3.mp3'),
  p1_2_1: require('../../../assets/onboarding/audio/p1_2_1.mp3'),
  p1_2_2: require('../../../assets/onboarding/audio/p1_2_2.mp3'),
  p1_2_3: require('../../../assets/onboarding/audio/p1_2_3.mp3'),
  p1_3_1: require('../../../assets/onboarding/audio/p1_3_1.mp3'),
  p1_3_2: require('../../../assets/onboarding/audio/p1_3_2.mp3'),
  p1_3_3: require('../../../assets/onboarding/audio/p1_3_3.mp3'),
  p1_4_1: require('../../../assets/onboarding/audio/p1_4_1.mp3'),
  p1_4_2: require('../../../assets/onboarding/audio/p1_4_2.mp3'),
  p1_5_1: require('../../../assets/onboarding/audio/p1_5_1.mp3'),
  p1_5_2: require('../../../assets/onboarding/audio/p1_5_2.mp3'),
  p1_5_3: require('../../../assets/onboarding/audio/p1_5_3.mp3'),
  p1_6_1: require('../../../assets/onboarding/audio/p1_6_1.mp3'),
  p1_6_2: require('../../../assets/onboarding/audio/p1_6_2.mp3'),
  s1_action_admin_1: require('../../../assets/onboarding/audio/s1_action_admin_1.mp3'),
  s1_action_economic_1: require('../../../assets/onboarding/audio/s1_action_economic_1.mp3'),
  s1_action_health_1: require('../../../assets/onboarding/audio/s1_action_health_1.mp3'),
  s1_action_personal_1: require('../../../assets/onboarding/audio/s1_action_personal_1.mp3'),
  s1_action_social_1: require('../../../assets/onboarding/audio/s1_action_social_1.mp3'),
  s1_done_1: require('../../../assets/onboarding/audio/s1_done_1.mp3'),
  s1_handoff_1: require('../../../assets/onboarding/audio/s1_handoff_1.mp3'),
  s1_handoff_2: require('../../../assets/onboarding/audio/s1_handoff_2.mp3'),
  s1_intro_1: require('../../../assets/onboarding/audio/s1_intro_1.mp3'),
  s1_intro_2: require('../../../assets/onboarding/audio/s1_intro_2.mp3'),
  s1_intro_3: require('../../../assets/onboarding/audio/s1_intro_3.mp3'),
  s1_intro_4: require('../../../assets/onboarding/audio/s1_intro_4.mp3'),
  s1_return_1: require('../../../assets/onboarding/audio/s1_return_1.mp3'),
  s1_return_2: require('../../../assets/onboarding/audio/s1_return_2.mp3'),
  s1_save_1: require('../../../assets/onboarding/audio/s1_save_1.mp3'),
  s2_action_add_1: require('../../../assets/onboarding/audio/s2_action_add_1.mp3'),
  s2_action_repeat_1: require('../../../assets/onboarding/audio/s2_action_repeat_1.mp3'),
  s2_action_save_1: require('../../../assets/onboarding/audio/s2_action_save_1.mp3'),
  s2_action_title_1: require('../../../assets/onboarding/audio/s2_action_title_1.mp3'),
  s2_action_when_1: require('../../../assets/onboarding/audio/s2_action_when_1.mp3'),
  s2_done_1: require('../../../assets/onboarding/audio/s2_done_1.mp3'),
  s2_handoff_1: require('../../../assets/onboarding/audio/s2_handoff_1.mp3'),
  s2_handoff_2: require('../../../assets/onboarding/audio/s2_handoff_2.mp3'),
  s2_intro_1: require('../../../assets/onboarding/audio/s2_intro_1.mp3'),
  s2_intro_2: require('../../../assets/onboarding/audio/s2_intro_2.mp3'),
  s2_intro_3: require('../../../assets/onboarding/audio/s2_intro_3.mp3'),
  s2_intro_4: require('../../../assets/onboarding/audio/s2_intro_4.mp3'),
  s2_return_1: require('../../../assets/onboarding/audio/s2_return_1.mp3'),
  s2_return_2: require('../../../assets/onboarding/audio/s2_return_2.mp3'),
  s3_action_admin_1: require('../../../assets/onboarding/audio/s3_action_admin_1.mp3'),
  s3_action_economic_1: require('../../../assets/onboarding/audio/s3_action_economic_1.mp3'),
  s3_action_health_1: require('../../../assets/onboarding/audio/s3_action_health_1.mp3'),
  s3_action_personal_1: require('../../../assets/onboarding/audio/s3_action_personal_1.mp3'),
  s3_action_social_1: require('../../../assets/onboarding/audio/s3_action_social_1.mp3'),
  s3_done_1: require('../../../assets/onboarding/audio/s3_done_1.mp3'),
  s3_done_2: require('../../../assets/onboarding/audio/s3_done_2.mp3'),
  s3_handoff_1: require('../../../assets/onboarding/audio/s3_handoff_1.mp3'),
  s3_handoff_2: require('../../../assets/onboarding/audio/s3_handoff_2.mp3'),
  s3_intro_1: require('../../../assets/onboarding/audio/s3_intro_1.mp3'),
  s3_intro_2: require('../../../assets/onboarding/audio/s3_intro_2.mp3'),
  s3_intro_3: require('../../../assets/onboarding/audio/s3_intro_3.mp3'),
  s3_intro_4: require('../../../assets/onboarding/audio/s3_intro_4.mp3'),
  s3_rate_1_1: require('../../../assets/onboarding/audio/s3_rate_1_1.mp3'),
  s3_rate_2_1: require('../../../assets/onboarding/audio/s3_rate_2_1.mp3'),
  s3_rate_view_1: require('../../../assets/onboarding/audio/s3_rate_view_1.mp3'),
  s3_return_1: require('../../../assets/onboarding/audio/s3_return_1.mp3'),
  s3_return_2: require('../../../assets/onboarding/audio/s3_return_2.mp3'),
  s4_action_link_1: require('../../../assets/onboarding/audio/s4_action_link_1.mp3'),
  s4_action_own_1: require('../../../assets/onboarding/audio/s4_action_own_1.mp3'),
  s4_action_own_2: require('../../../assets/onboarding/audio/s4_action_own_2.mp3'),
  s4_action_time_1: require('../../../assets/onboarding/audio/s4_action_time_1.mp3'),
  s4_done_1: require('../../../assets/onboarding/audio/s4_done_1.mp3'),
  s4_done_2: require('../../../assets/onboarding/audio/s4_done_2.mp3'),
  s4_handoff_1: require('../../../assets/onboarding/audio/s4_handoff_1.mp3'),
  s4_handoff_2: require('../../../assets/onboarding/audio/s4_handoff_2.mp3'),
  s4_intro_1: require('../../../assets/onboarding/audio/s4_intro_1.mp3'),
  s4_intro_2: require('../../../assets/onboarding/audio/s4_intro_2.mp3'),
  s4_intro_3: require('../../../assets/onboarding/audio/s4_intro_3.mp3'),
  s4_intro_4: require('../../../assets/onboarding/audio/s4_intro_4.mp3'),
  s4_return_1: require('../../../assets/onboarding/audio/s4_return_1.mp3'),
  s4_return_2: require('../../../assets/onboarding/audio/s4_return_2.mp3'),
  s5_action_note_1: require('../../../assets/onboarding/audio/s5_action_note_1.mp3'),
  s5_action_outcome_1: require('../../../assets/onboarding/audio/s5_action_outcome_1.mp3'),
  s5_action_save_1: require('../../../assets/onboarding/audio/s5_action_save_1.mp3'),
  s5_done_1: require('../../../assets/onboarding/audio/s5_done_1.mp3'),
  s5_handoff_1: require('../../../assets/onboarding/audio/s5_handoff_1.mp3'),
  s5_handoff_2: require('../../../assets/onboarding/audio/s5_handoff_2.mp3'),
  s5_intro_1: require('../../../assets/onboarding/audio/s5_intro_1.mp3'),
  s5_intro_2: require('../../../assets/onboarding/audio/s5_intro_2.mp3'),
  s5_intro_3: require('../../../assets/onboarding/audio/s5_intro_3.mp3'),
  s5_intro_4: require('../../../assets/onboarding/audio/s5_intro_4.mp3'),
  s5_return_1: require('../../../assets/onboarding/audio/s5_return_1.mp3'),
  s5_return_2: require('../../../assets/onboarding/audio/s5_return_2.mp3'),
};
